/**
 * NONCONFORMANCE STORE
 */

import api from "Api";

import { printNonconformance } from "Modules/manufacturing/nonconformance/config/api.nonconformance";

const state = {
    page: {},
    dashboard_nonconformances: null,
    nonconformance: null,
    nonconformances: JSON.parse(localStorage.getItem("nonconformances")) || null,
    nonconformances_filter: {
        search: "",
        page_size: 0,
        page_num: 1,
    },
    nonconformance_type: null,
    nonconformance_types: JSON.parse(localStorage.getItem("nonconformance_types")) || null,
    nonconformance_types_filter: {
        search: "",
        page_size: 0,
        page_num: 1,
    },
};

// getters
const getters = {};

// actions
const actions = {
    async fetchNonconformance({ rootState, commit }, payload) {
        try {
            let body = "";

            if (payload.body) {
                switch (payload.method) {
                    case "post":
                    case "put":
                    case "patch":
                        body = payload.body;
                        break;
                    default:
                        body = payload.body;
                }
            }

            let response;

            switch (payload.method) {
                case "post":
                    response = await api.post(payload.url, body);

                    break;
                case "put":
                    response = await api.put(payload.url, body);

                    break;
                case "patch":
                    response = await api.patch(payload.url, body);

                    break;
                case "delete":
                    response = await api.delete(payload.url, {
                        params: body,
                    });

                    break;
                case "get":
                default:
                    response = await api.get(payload.url, {
                        params: body,
                    });
            }

            if (typeof response !== "undefined") {
                if (response.data && response.data.page) {
                    commit("commitNonconformance", {
                        property: "page",
                        with: response.data.page,
                    });
                }

                let split_state = payload.stateProperty ? (payload.stateProperty || "").split("|") || [] : [];
                let split_data = payload.dataProperty ? (payload.dataProperty || "").split("|") || [] : [];
                split_state.forEach((ss, i) => {
                    let sd = split_data[i] || ss;
                    if (payload.commit) {
                        commit("commitNonconformance", {
                            property: ss,
                            with: _.get(response.data, sd),
                        });
                        if (payload.localStorage) {
                            localStorage.setItem(ss, JSON.stringify(_.get(response.data, sd)));
                        }
                    }
                    if (payload.mutate) {
                        commit("mutateNonconformance", {
                            property: ss,
                            with: _.get(response.data, sd),
                            method: payload.method,
                            id: payload.id,
                            pk: payload.pk,
                        });
                    }
                });

                return response.data;
            } else {
                return;
            }
        } catch (error) {
            throw error;
        }
    },
    async printNonconformances({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printNonconformance(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
};

// mutations
const mutations = {
    commitNonconformance(state, payload) {
        _.set(state, payload.property, payload.with || null);
    },
    mutateNonconformance(state, payload) {
        if (payload.method == "post" && payload.with) {
            state[payload.property].push(payload.with);
        } else if (payload.method == "patch" && payload.property && payload.with && payload.pk) {
            let curr_id = payload.id ? payload.id : payload.with[payload.pk];
            let curr_item = state[payload.property][state[payload.property].findIndex((obj) => obj[payload.pk] == curr_id)];
            for (const key in payload.with) if (key in curr_item) curr_item[key] = payload.with[key];
        } else if (payload.method == "delete" && payload.property && payload.pk && payload.id) {
            state[payload.property].splice(
                state[payload.property].findIndex((obj) => obj[payload.pk] == payload.id),
                1
            );
        }
    },
    resetNonConformance(state) {
        // take the state values and set them back to default except for the rules_
        state.page = {};
        state.dashboard_nonconformances = null;
        state.nonconformance = null;
        state.nonconformances = JSON.parse(localStorage.getItem("nonconformances")) || null;
        state.nonconformances_filter = {
            search: "",
            page_size: 0,
            page_num: 1,
        };
        state.nonconformance_type = null;
        state.nonconformance_types = JSON.parse(localStorage.getItem("nonconformance_types")) || null;
        state.nonconformance_types_filter = {
            search: "",
            page_size: 0,
            page_num: 1,
        };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
